import type {
  UserCheckUserGetParams,
  UserCheckUserOutput,
  UserCreateEmailOTPInput,
  UserCreateOTPInput,
  UserGetAgentByUsernameParams,
  UserGetAgentOutput,
  UserGetAgentParams,
  UserGetFeatureFlagsOutput,
  UserLoginByEmailInput,
  UserLoginByPhoneInput,
  UserQuickKYCInput,
  UserRefreshTokenInput,
  UserRegisterByEmailInput,
  UserRegisterByPhoneInput,
  UserResendOTPInput,
  UserResendOTPOutput,
  UserSetUserEmailInput,
  UserSetUserPhoneInput,
} from '../api'
import { api } from '../api'

const loginByPhone = async (data: UserLoginByPhoneInput) => {
  return await api.v1.userLoginByPhone(data)
}

const loginByEmail = async (data: UserLoginByEmailInput) => {
  return await api.v1.userLoginByEmail(data)
}

const registerByPhone = async (data: UserRegisterByPhoneInput) => {
  return await api.v1.userRegisterByPhone(data)
}

const registerByEmail = async (data: UserRegisterByEmailInput) => {
  return await api.v1.userRegisterByEmail(data)
}

const details = async () => {
  return await api.v1.userAuthVerify({})
}

const refresh = async (data: UserRefreshTokenInput) => {
  return await api.v1.userAuthRefresh(data)
}

const verify = async (data: UserQuickKYCInput) => {
  return await api.v1.userVerifyPhoneOwner(data)
}

const setUserEmail = async (data: UserSetUserEmailInput) => {
  return await api.v1.userSetUserEmail(data)
}

const setUserPhone = async (data: UserSetUserPhoneInput) => {
  return await api.v1.userSetUserPhone(data)
}
const createEmailOtp = async (data: UserCreateEmailOTPInput) => {
  return await api.v1.userCreateEmailOtp({
    ...data,
  })
}
const createPhoneOtp = async (data: UserCreateOTPInput) => {
  return await api.v1.userCreatePhoneOtp({
    ...data,
  })
}

const resendOtp = async (
  data: UserResendOTPInput,
): Promise<UserResendOTPOutput> => {
  return api.v1.userResendOtp(data).then((res) => res.data)
}

const checkUser = async (
  data: UserCheckUserGetParams,
): Promise<UserCheckUserOutput> => {
  return api.v1.userCheckUserGet(data).then((res) => res.data)
}

const getAgent = async (
  data: UserGetAgentParams,
): Promise<UserGetAgentOutput> => {
  return api.v1.userGetAgent(data).then((res) => res.data)
}

const getAgentByUsername = async (
  data: UserGetAgentByUsernameParams,
): Promise<UserGetAgentOutput> => {
  return api.v1.userGetAgentByUsername(data).then((res) => res.data)
}
const getFeatureFlags = async (): Promise<UserGetFeatureFlagsOutput> => {
  return api.v1.userGetFeatureFlags().then((res) => res.data)
}

export default {
  loginByPhone,
  loginByEmail,
  registerByPhone,
  registerByEmail,
  details,
  refresh,
  verify,
  setUserEmail,
  setUserPhone,
  createEmailOtp,
  createPhoneOtp,
  resendOtp,
  checkUser,
  getAgent,
  getAgentByUsername,
  getFeatureFlags,
}
